/**
 * SlotPlaceLine — D7 (PROD-639, PD7-1/2). Where the picked visit will be: a map pin, then the
 * location's name (only when the physician has more than one location) and its address.
 *
 * `place` comes from utils/bookableSlots.js slotPlace(); null renders NOTHING, which is what
 * every screen shows for an API without `locations` (before D7) and for a virtual visit.
 * Both parts are data from GET /slots: this component adds no copy of its own.
 */
import { MapPin } from 'lucide-react'

export default function SlotPlaceLine({ place, className = '', color = '#15354F' }) {
  if (!place || (!place.name && !place.address)) return null
  const text = [place.name, place.address].filter(Boolean).join(' · ')
  return (
    <p className={`flex items-start gap-1.5 text-[12px] ${className}`} style={{ color }} data-slot-place="">
      <MapPin size={13} className="mt-[2px] shrink-0 text-[#46A8F9]" />
      <span>{text}</span>
    </p>
  )
}
